var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"word"},[_c('div'),_c('section',[_c('h1',[_vm._v(_vm._s(_vm.word.title))]),_c('p',[_vm._v(_vm._s(_vm.word.body))])]),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }